module.exports = __webpack_public_path__ + "assets/img/266101.465b52ed.png";